module.exports = __webpack_public_path__ + "img/1515420953.ce29d6ca.jpg";